import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';

import styles from './styles/Meeting.module.scss'
import Alert from 'react-bootstrap/esm/Alert'
import {Root} from 'Root'
import Participant from './Components/Participant'
import {calculateTimeUntilEnd, isActiveMeeting, isPastMeeting} from 'Utils/time'
import Button from 'react-bootstrap/esm/Button'
import Modal from "react-bootstrap/Modal";
import {FaStar} from "react-icons/fa";

const Meeting = ({ location , ...props }) => {
  const Video = require('twilio-video')
  const {session, refreshSession}  = useContext(SessionContext)

  const [timeLeft, setTimeLeft] = useState(null)
  const meeting = location.state.data.meeting
  const token = location.state.data.token
  // const meeting = {id: 'fake_room_id_1', date: '', duration: 60, startTime: '', primaryCommunication: 'VIDEO'}
  // const token = 'eyJjdHkiOiJ0d2lsaW8tZnBhO3Y9MSIsInR5cCI6IkpXVCIsImFsZyI6IkhTMjU2In0.eyJpc3MiOiJTS2U5NzdjMzFiN2IxYjdiMjZlNTcwM2Y0ODg4Zjk0ZDBkIiwiZXhwIjoxNzM3NjAxNDE1LCJncmFudHMiOnsiaWRlbnRpdHkiOiJlY3VubmluMkBhbHVtbmkubmQuZWR1IiwidmlkZW8iOnsicm9vbSI6ImZha2Vfcm9vbV9pZF8xIn19LCJqdGkiOiJTS2U5NzdjMzFiN2IxYjdiMjZlNTcwM2Y0ODg4Zjk0ZDBkLTE3Mzc1OTc4MjQiLCJzdWIiOiJBQzRiNDExNWMzMTQ5YzNiZDc0MTNkNTViMzlhOWJkZTEwIn0.rlw10joK3AJT3tcWtnF0mEJtOxrq2AswyQ6Egk-eh1E'
  const [participants, setParticipants] = useState([])
  const [room, setRoom] = useState(null)
  const [error, setError] = useState(null)
  const [showExitModal, setShowExitModal] = useState(false);

  const roomName = meeting.id
  const remoteParticipants = participants.map(participant => (
    <>
      <Participant style={{ display: 'block' }}
        key={participant.sid} comm={meeting.primaryCommunication}
        participant={participant} type={'remote'}/>
    </>
  ))

  useEffect(() => {
    const participantConnected = participant => {
      setParticipants(prevParticipants => [...prevParticipants, participant])
    }
    const participantDisconnected = participant => {
      setParticipants(prevParticipants =>
        prevParticipants.filter(p => p !== participant)
      )
    }

    Video.connect(token, {
      name: roomName, audio: audio, video: video
    }).then(room => {
      setRoom(room)
      room.on('participantConnected', participantConnected)
      room.on('participantDisconnected', participantDisconnected)

      room.participants.forEach(participantConnected)
    }).catch(err => {
      setError("Unable to join call. Contact support if error persists.")
      console.log(err)})

    return () => {
      setRoom(currentRoom => {
        if (currentRoom && currentRoom.localParticipant.state === 'connected') {
          console.log(currentRoom.localParticipant.tracks)
          currentRoom.localParticipant.tracks.forEach(function (trackPublication) {
            console.log(trackPublication)
            if(trackPublication){
              trackPublication.track.stop()
            }
          })
          currentRoom.disconnect()
          return null
        } else {
          return currentRoom
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomName, token])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isPastMeeting(meeting.date, meeting.startTime, meeting.duration)) {
        window.location.href = '/dashboard/meetings'
        return
      }
      setTimeLeft(calculateTimeUntilEnd(meeting.date, meeting.startTime, meeting.duration))
    }, 10000)
    return () => clearTimeout(timer)
  })

  var type = meeting.primaryCommunication
  var audio = true
  var video = type === 'VIDEO'

  useEffect(() => {
    setTimeLeft(calculateTimeUntilEnd(meeting.date, meeting.startTime, meeting.duration))
  }, [meeting.date, meeting.startTime, meeting.duration])

  function disableLocalTracks () {
    room.localParticipant.tracks.forEach(function (track) {
      if (typeof track.stop === 'function') {
        // safe to use the function
        track.stop()
      }
      track.unpublish()
    })

    Root.collegeApi.leaveMeeting(meeting.id, session.jwt).then(res => {
      if (res.status === 200 && res.data) {}
    }).catch(err => {
      console.log(err)
    });
  }

  return <div className={styles.background}>
    <div style={{ position: 'absolute', width:"100%", zIndex: 100 }}>
      {error && <Alert variant={"danger"}>{error}</Alert>}
    </div>
    <p style={{ position: 'absolute', right: '1em', bottom: '1em', zIndex: 100 }} className={styles.test}> Time Left : {
      timeLeft && Object.keys(timeLeft).map((interval, idx) =>
        <span key={idx}>{(interval === 'minutes') && `${timeLeft[interval]} ${interval}`} </span>
      )
    }</p>

    {isPastMeeting(meeting.date, meeting.startTime, meeting.duration) &&
      <p style={{ position: 'absolute', width: '100%', top: '50%' }} className={styles.test}>Meeting has ended</p>
    }
    {(!remoteParticipants || remoteParticipants.length === 0) && isActiveMeeting(meeting.date, meeting.startTime) &&
      <p style={{ position: 'absolute', width: '100%', top: '50%', textAlign: 'center'}} className={styles.test}>Waiting for participant to join</p>}
    {(remoteParticipants && remoteParticipants.length > 0) && isActiveMeeting(meeting.date, meeting.startTime) &&
      <p style={{ position: 'absolute', width: '100%', top: '50%', textAlign: 'center'}} className={styles.test}>Participant is in the room. Start chatting!</p>
    }
    <div style={{ transform: 'scale(-1, 1)' }} className={styles.remote}>{remoteParticipants}</div>
    <div style={{ transform: 'scale(-1, 1)' }} className={styles.local}>
      {room ? (
        <Participant
          key={room.localParticipant.sid} comm={meeting.primaryCommunication}
          participant={room.localParticipant} type={'local'}
        />
      ) : (
        ''
      )}
    </div>
    <div className='d-flex justify-content-center'>
      <Button className='btnFill red md mt-3' style={{zIndex:1000}} onClick={()=> {disableLocalTracks(); window.location = '/dashboard';}}>Exit Meeting</Button>
    </div>
    {<Modal show={showExitModal} onHide={()=> {window.location = '/dashboard'; setShowExitModal(false); }}>
      <Modal.Header>
        <Modal.Title className="d-flex align-items-center"><FaStar className="mr-2" fill="orange"/> Leave a Review!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please remember to head to your dashboard and leave a review after your meeting!</p>
      </Modal.Body>
    </Modal>}
  </div>
}


export default (Meeting)
